"use client";

import React from "react";
import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { useMultiLanguages } from "../utils/multiLanguage/MultiLanguageContext";

export default function FooterClient({
  initialFooters,
  initialProfilLinks,
  initialPublikasiLinks,
}) {
  const pathname = usePathname();
  const isArahKebijakan = pathname === "/arah-kebijakan";
  const { translateByCode, locale } = useMultiLanguages();

  if (!initialFooters) return null;

  const footers = initialFooters;

  return (
    <footer
      className={`${
        isArahKebijakan ? "hidden" : "flex"
      } flex-col justify-center items-center`}
    >
      {/* Main Footer Section */}
      <div className="flex flex-col md:flex-row w-full justify-start items-start gap-8 md:gap-10 bg-cust-blue text-white px-8 md:px-10 lg:px-20 py-8 md:py-10">
        <div className="flex flex-col gap-4 w-full md:w-2/4 items-center md:items-start">
          <div className="w-72 h-20 relative">
            <Image
              src={
                locale === "id"
                  ? `${process.env.NEXT_PUBLIC_STRAPI_URL}${footers.logo?.url}`
                  : "/image/logoUmkm6_white.svg"
              }
              alt={footers.logo?.name || "Footer logo"}
              width={320}
              height={80}
              className="w-72 h-20 object-contain"
              priority={false} // Prevent layout shift
            />
          </div>

          <p className="text-base font-normal text-center md:text-left">
            {footers.alamat}
          </p>

          <Link
            className="text-base font-normal text-center md:text-left hover:underline"
            href={`tel:${footers.call_center}`}
          >
            Call Center {footers.call_center}
          </Link>

          <Link
            href={`mailto:${footers.email}`}
            className="text-base font-normal text-center md:text-left hover:underline"
          >
            {footers.email}
          </Link>

          <div className="flex flex-row justify-start items-center gap-5">
            {[
              {
                src: "/image/InstagramCircle.svg",
                url: footers.url_instagram,
                alt: "Instagram",
              },
              {
                src: "/image/FacebookCircle.svg",
                url: footers.url_facebook,
                alt: "Facebook",
              },
              {
                src: "/image/YoutubeCircle.svg",
                url: footers.url_youtube,
                alt: "YouTube",
              },
              {
                src: "/image/TwitterCircle.svg",
                url: footers.url_x,
                alt: "Twitter/X",
              },
            ].map((icon, i) => (
              <button
                key={i}
                onClick={() =>
                  window.open(icon.url, "_blank", "noopener,noreferrer")
                }
                aria-label={icon.alt}
                className="cursor-pointer"
              >
                <Image
                  src={icon.src}
                  alt={icon.alt}
                  width={32}
                  height={32}
                  className="w-9 h-9"
                  loading="lazy"
                />
              </button>
            ))}
          </div>
        </div>

        <hr className="block md:hidden w-full border-white h-1" />
      </div>

      {/* Bottom Bar */}
      <div className="flex justify-center items-center text-xs font-light w-full text-white bg-[#132432] px-8 md:px-10 lg:px-20 py-2 text-center">
        {translateByCode("key00137")}
      </div>
    </footer>
  );
}
